import { createIcon } from '@chakra-ui/react'

const IconLock = createIcon({
  displayName: 'IconLock',
  viewBox: '0 0 20 20',
  defaultProps: {
    boxSize: '20px'
  },
  path: (
    <path
      d="M10 1.667A4.167 4.167 0 0 0 5.833 5.833V8.333A1.667 1.667 0 0 0 4.167 10v6.667A1.667 1.667 0 0 0 5.833 18.333h8.334a1.667 1.667 0 0 0 1.666-1.666V10a1.667 1.667 0 0 0-1.666-1.667V5.833A4.167 4.167 0 0 0 10 1.667Zm3.333 6.666H6.667V5.833a3.333 3.333 0 0 1 6.666 0v2.5ZM5.833 10h8.334v6.667H5.833V10Zm3.334 2.5a.833.833 0 0 1 1.666 0v1.667a.833.833 0 0 1-1.666 0V12.5Z"
      fill="currentColor"
    />
  )
})

export default IconLock
